<section class="splide" #splide>
  <div class="splide__track">
    <ul class="splide__list">
      <ng-content></ng-content>
    </ul>
  </div>
</section>
